// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/bg_color_picker.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/caret_up_down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/ordered_list.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor {
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  background-color: #ffffff;
  border-radius: 16px;
  min-height: 172px;
  width: 100%;
  display: flex;
  flex-direction: column;
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.ql-toolbar {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-color: #e2e8f0 !important;
  background-color: #fafafa;
  height: 48px;
}

.ql-picker-options {
  left: 0;
}

.ql-toolbar .ql-size {
  display: flex;
  align-items: center;
  padding: 7px 8px;
  position: relative;
  width: 48px !important;
  height: 32px !important;
  font-size: 14px;
  font-weight: 500;
  border-inline: 1px solid #e2e8f0;
}

.editor svg,
.editor line,
.editor path,
.editor rect,
.editor polyline {
  stroke: #475569 !important;
  opacity: 1 !important;
}

.ql-strike path {
  stroke: none !important;
  fill: #475569 !important;
}

.ql-formats {
  margin-right: 0 !important;
}

.ql-picker-label {
  color: #475569 !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
  border: none !important;
}

.ql-picker-label:hover {
  color: #475569 !important;
}

.ql-picker-label:before {
  line-height: 0 !important;
  margin-top: 10px;
}

.ql-toolbar .ql-size svg,
.ql-toolbar .ql-background svg,
.ql-toolbar .ql-list[value="ordered"] svg {
  display: none;
}

.ql-toolbar button {
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.ql-toolbar button svg {
  width: 16px !important;
  height: 16px !important;
}

.ql-color,
.ql-background {
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  position: relative;
}

.ql-color svg {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ql-background .ql-picker-label::after {
  content: "";
  width: 16px;
  height: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / contain no-repeat;
}

.ql-size .ql-picker-label::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center / contain no-repeat;
}

.ql-toolbar button.ql-list[value="ordered"]::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center / contain no-repeat;
}

.ql-container {
  background-color: #fff;
  flex: 1;
  border: none !important;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.ql-tooltip {
  left: 50px !important;
}

@media screen and (max-width: 410px) {
  .ql-toolbar button {
    width: 26px !important;
    height: 26px !important;

    .ql-color,
    .ql-background {
      width: 26px !important;
      height: 26px !important;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TextEditor/TextEditor.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;;;EAKE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,8EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,8EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8EAA0E;AAC5E;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;;IAEvB;;MAEE,sBAAsB;MACtB,uBAAuB;IACzB;EACF;AACF","sourcesContent":[".editor {\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  background-color: #ffffff;\r\n  border-radius: 16px;\r\n  min-height: 172px;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  word-break: break-word;\r\n  white-space: pre-wrap;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n.ql-toolbar {\r\n  border-top-left-radius: 16px;\r\n  border-top-right-radius: 16px;\r\n  border-color: #e2e8f0 !important;\r\n  background-color: #fafafa;\r\n  height: 48px;\r\n}\r\n\r\n.ql-picker-options {\r\n  left: 0;\r\n}\r\n\r\n.ql-toolbar .ql-size {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 7px 8px;\r\n  position: relative;\r\n  width: 48px !important;\r\n  height: 32px !important;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border-inline: 1px solid #e2e8f0;\r\n}\r\n\r\n.editor svg,\r\n.editor line,\r\n.editor path,\r\n.editor rect,\r\n.editor polyline {\r\n  stroke: #475569 !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.ql-strike path {\r\n  stroke: none !important;\r\n  fill: #475569 !important;\r\n}\r\n\r\n.ql-formats {\r\n  margin-right: 0 !important;\r\n}\r\n\r\n.ql-picker-label {\r\n  color: #475569 !important;\r\n  padding: 0 !important;\r\n  display: flex;\r\n  align-items: center;\r\n  border: none !important;\r\n}\r\n\r\n.ql-picker-label:hover {\r\n  color: #475569 !important;\r\n}\r\n\r\n.ql-picker-label:before {\r\n  line-height: 0 !important;\r\n  margin-top: 10px;\r\n}\r\n\r\n.ql-toolbar .ql-size svg,\r\n.ql-toolbar .ql-background svg,\r\n.ql-toolbar .ql-list[value=\"ordered\"] svg {\r\n  display: none;\r\n}\r\n\r\n.ql-toolbar button {\r\n  width: 32px !important;\r\n  height: 32px !important;\r\n  padding: 0 !important;\r\n  display: flex !important;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.ql-toolbar button svg {\r\n  width: 16px !important;\r\n  height: 16px !important;\r\n}\r\n\r\n.ql-color,\r\n.ql-background {\r\n  width: 32px !important;\r\n  height: 32px !important;\r\n  padding: 0 !important;\r\n  position: relative;\r\n}\r\n\r\n.ql-color svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.ql-background .ql-picker-label::after {\r\n  content: \"\";\r\n  width: 16px;\r\n  height: 16px;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background: url(\"/src/assets/bg_color_picker.svg\") center / contain no-repeat;\r\n}\r\n\r\n.ql-size .ql-picker-label::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  right: 0;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 12px;\r\n  height: 12px;\r\n  background: url(\"/src/assets/caret_up_down.svg\") center / contain no-repeat;\r\n}\r\n\r\n.ql-toolbar button.ql-list[value=\"ordered\"]::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 16px;\r\n  background: url(\"/src/assets/ordered_list.svg\") center / contain no-repeat;\r\n}\r\n\r\n.ql-container {\r\n  background-color: #fff;\r\n  flex: 1;\r\n  border: none !important;\r\n  border-bottom-left-radius: 16px;\r\n  border-bottom-right-radius: 16px;\r\n}\r\n\r\n.ql-tooltip {\r\n  left: 50px !important;\r\n}\r\n\r\n@media screen and (max-width: 410px) {\r\n  .ql-toolbar button {\r\n    width: 26px !important;\r\n    height: 26px !important;\r\n\r\n    .ql-color,\r\n    .ql-background {\r\n      width: 26px !important;\r\n      height: 26px !important;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
